import React, { useEffect, useRef } from 'react';

import { TP } from 'constants/index';

import { useTranslation } from 'src/i18n';

import classes from './BookMeeting.module.scss';

const BookMeeting = () => {
  const { t } = useTranslation('NS_CASTING_TOOL');
  const scriptLoadedRef = useRef(false);
  const buttonContainerRef = useRef(null);

  useEffect(() => {
    if (scriptLoadedRef.current) {
      return;
    }

    const link = document.createElement('link');
    link.href = 'https://calendar.google.com/calendar/scheduling-button-script.css';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    const script = document.createElement('script');
    script.src = 'https://calendar.google.com/calendar/scheduling-button-script.js';
    script.async = true;

    script.onload = () => {
      window.calendar?.schedulingButton?.load({
        url:
          'https://calendar.google.com/calendar/appointments/schedules/AcZssZ0g7Rc2pDlNIR6ZS2A71sq0JuVRjvbfjduHNSE3G3HXYuSbEjzZv1GxaOigo2v8eA-1IyNgIaqn?gv=true',
        color: '#039BE5',
        label: t(`${TP}.BOOK_MEETING_TEXT`),
        target: buttonContainerRef.current,
      });
    };

    document.body.appendChild(script);

    scriptLoadedRef.current = true;
  }, []);

  return (
    <div className={classes.bookMeeting}>
      <div ref={buttonContainerRef} />
    </div>
  );
};

export default BookMeeting;
